import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

import Navbar from './Navbar';
import ProfileSidebar from './ProfileSidebar';

const ProfileLayout = () => {
  const [isTourOpen, setIsTourOpen] = useState(false);
  return (
    <div className="flex flex-col min-h-screen bg-[#121316]">
      {/* Top Navigation Bar */}
      <Navbar type={'profile'} />
      <div className="flex w-full h-full">
        {/* Sidebar - Only visible on large screens */}
        <div className="hidden lg:block">
          <ProfileSidebar setIsTourOpen={setIsTourOpen} />
        </div>

        <div className="bg-[#121316] h-auto text-white flex flex-1 flex-col items-center">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ProfileLayout;
